var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_44875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.90394 27.1064C9.30109 25.295 7.95389 22.5669 5.64706 22.5883C3.34049 22.5668 1.99285 25.2955 3.39025 27.1064C2.47523 27.7939 1.88236 28.8877 1.88236 30.1176V32H9.41177V30.1176C9.41177 28.8877 8.81889 27.7939 7.90394 27.1064ZM4.70589 25.4118C4.70589 24.8927 5.1281 24.4706 5.64706 24.4706C6.89393 24.5178 6.89362 26.3059 5.64706 26.3529C5.1281 26.3529 4.70589 25.9308 4.70589 25.4118ZM3.76471 30.1176C3.85964 27.6233 7.43536 27.6252 7.52941 30.1176H3.76471Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6098 27.1064C30.007 25.295 28.6598 22.5669 26.3529 22.5883C24.0464 22.5668 22.6987 25.2955 24.0961 27.1064C23.1811 27.7939 22.5882 28.8877 22.5882 30.1176V32H30.1176V30.1176C30.1176 28.8877 29.5248 27.7939 28.6098 27.1064ZM25.4118 25.4118C25.4118 24.8927 25.8339 24.4706 26.3529 24.4706C27.5998 24.5178 27.5995 26.3059 26.3529 26.3529C25.8339 26.3529 25.4118 25.9308 25.4118 25.4118ZM24.4706 30.1176C24.5655 27.6233 28.1412 27.6252 28.2353 30.1176H24.4706Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2569 27.1064C19.654 25.295 18.3068 22.5669 16 22.5883C13.6934 22.5668 12.3458 25.2955 13.7432 27.1064C12.8282 27.7939 12.2353 28.8877 12.2353 30.1176V32H19.7647V30.1176C19.7647 28.8877 19.1718 27.7939 18.2569 27.1064ZM15.0588 25.4118C15.0588 24.8927 15.481 24.4706 16 24.4706C17.2469 24.5178 17.2466 26.3059 16 26.3529C15.481 26.3529 15.0588 25.9308 15.0588 25.4118ZM14.1177 30.1176C14.2126 27.6233 17.7883 27.6252 17.8824 30.1176H14.1177Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V20.7059H32V0H0ZM30.1176 18.8235H1.88235V1.88235H30.1176V18.8235Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.9412C19.6328 16.9412 22.5882 13.9858 22.5882 10.3529C22.2571 1.62472 9.74162 1.62711 9.41177 10.353C9.41177 13.9858 12.3672 16.9412 16 16.9412ZM15.0588 10.3529C15.0588 9.83398 15.481 9.41176 16 9.41176C17.2469 9.45901 17.2466 11.2471 16 11.2941C15.481 11.2941 15.0588 10.8719 15.0588 10.3529ZM14.1556 14.6819C14.5979 12.6744 17.4204 12.7012 17.8446 14.6818C16.6856 15.1776 15.3475 15.1917 14.1556 14.6819ZM16 5.64706C20.0922 5.63451 22.2241 10.6007 19.4498 13.5491C19.1936 12.9643 18.7891 12.4459 18.258 12.0461C19.6533 10.2344 18.3059 7.50802 15.9999 7.52941C13.6934 7.50795 12.3457 10.2366 13.7431 12.0476C13.227 12.4353 12.8141 12.9527 12.5516 13.5506C9.77425 10.6014 11.9088 5.63394 16 5.64706Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5294 3.76471H28.2353V5.64706H23.5294V3.76471Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4706 7.52941H28.2353V9.41176H24.4706V7.52941Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4706 11.2941H28.2353V13.1765H24.4706V11.2941Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5294 15.0588H28.2353V16.9412H23.5294V15.0588Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7647 3.76471H8.47058V5.64706H3.7647V3.76471Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7647 7.52941H7.52941V9.41176H3.7647V7.52941Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7647 11.2941H7.52941V13.1765H3.7647V11.2941Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7647 15.0588H8.47058V16.9412H3.7647V15.0588Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_44875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.8d0725471d79f73e2f5e2e2b586042c1.svg";
export { ForwardRef as ReactComponent };